'use client';

import { useEffect } from 'react';
import { useSuperstarDetailId } from './context';
import { sendSuperstarDetailsLoadEvent } from '@wwe-portal/web/libs/analytics/superstars-v2';

export const SuperstarDetailsPageLoadAnalytics = () => {
  const superstarId = useSuperstarDetailId();
  useEffect(() => {
    sendSuperstarDetailsLoadEvent(superstarId);
  }, [superstarId]);
  return null;
};
